module.exports = __webpack_public_path__ + "img/eye.e9ecd966.svg";